var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddPicture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 6H17.8L16 4H10V6H15.1L17 8H21V20H5V11H3V20C3 21.1 3.9 22 5 22H21C22.1 22 23 21.1 23 20V8C23 6.9 22.1 6 21 6ZM8 14C8 18.45 13.39 20.69 16.54 17.54C19.69 14.39 17.45 9 13 9C10.24 9 8 11.24 8 14ZM13 11C13.7885 11.0226 14.5385 11.346 15.0962 11.9038C15.654 12.4615 15.9774 13.2115 16 14C15.9774 14.7885 15.654 15.5385 15.0962 16.0962C14.5385 16.654 13.7885 16.9774 13 17C12.2115 16.9774 11.4615 16.654 10.9038 16.0962C10.346 15.5385 10.0226 14.7885 10 14C10.0226 13.2115 10.346 12.4615 10.9038 11.9038C11.4615 11.346 12.2115 11.0226 13 11ZM5 6H8V4H5V1H3V4H0V6H3V9H5",
    fill: "#F32B2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPicture);
export default __webpack_public_path__ + "static/media/add_picture.a7310573b48d8237660f42bc86e2a3ed.svg";
export { ForwardRef as ReactComponent };